export var PoiHeadingEnum;
(function (PoiHeadingEnum) {
    PoiHeadingEnum["name"] = "POI name";
    PoiHeadingEnum["alternativeName"] = "Alternative name";
    PoiHeadingEnum["type"] = "Type";
    PoiHeadingEnum["address"] = "Address";
    PoiHeadingEnum["ward"] = "Ward";
})(PoiHeadingEnum || (PoiHeadingEnum = {}));
